import { Moon, Sun } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";
import "./ThemeToggle.css";

function ThemeToggle({ variant = "default", className = "" }) {
  const { isDark, setTheme, toggleTheme } = useTheme();
  const extra = className ? ` ${className}` : "";

  if (variant === "icon") {
    return (
      <button
        type="button"
        className={`ess-theme-toggle ess-theme-toggle--icon${extra}`}
        onClick={toggleTheme}
        aria-label={isDark ? "التبديل إلى الوضع الفاتح" : "التبديل إلى الوضع الداكن"}
        aria-pressed={isDark}
        title={isDark ? "الوضع الفاتح" : "الوضع الداكن"}
      >
        {isDark ? <Sun size={18} /> : <Moon size={18} />}
      </button>
    );
  }

  return (
    <div
      className={`ess-theme-switch ess-theme-switch--${variant}${extra}`}
      role="group"
      aria-label="مظهر التطبيق"
    >
      <button
        type="button"
        className={`ess-theme-switch-btn${!isDark ? " is-active" : ""}`}
        onClick={() => setTheme("light")}
        aria-pressed={!isDark}
      >
        <Sun size={15} />
        <span>فاتح</span>
      </button>
      <button
        type="button"
        className={`ess-theme-switch-btn${isDark ? " is-active" : ""}`}
        onClick={() => setTheme("dark")}
        aria-pressed={isDark}
      >
        <Moon size={15} />
        <span>داكن</span>
      </button>
    </div>
  );
}

export default ThemeToggle;
